import {useMoment} from 'common/useMoment';
import {CalcPriceResult, DBPrice} from 'common/types';
import {BASE_PRICE_PEOPLE} from 'common/constants';

const getMatchingPrices = (prices: DBPrice[], from: Date, to: Date): DBPrice[] => {
  const moment = useMoment();
  const dateFrom = moment.utc(from).startOf('day');
  const dateTo = moment.utc(to).endOf('day');
  const matching = prices.filter(price => {
    const priceFrom = moment.utc(price.from).startOf('day');
    const priceTo = moment.utc(price.to).endOf('day');
    const inside = priceFrom.isSameOrBefore(dateFrom) && priceTo.isSameOrAfter(dateTo);
    const containFrom =
      priceFrom.isSameOrBefore(dateFrom) && priceTo.isSameOrAfter(dateFrom) && priceTo.isSameOrBefore(dateTo);
    const containTo =
      priceFrom.isSameOrBefore(dateTo) && priceFrom.isSameOrAfter(dateFrom) && priceTo.isSameOrAfter(dateTo);
    const intersect = priceFrom.isSameOrAfter(dateFrom) && priceTo.isSameOrBefore(dateTo);
    return inside || containFrom || containTo || intersect;
  });
  return matching.map(item => {
    const itemFrom = dateFrom.isBefore(moment.utc(item.from).startOf('day')) ? item.from : from;
    const itemTo = dateTo.isAfter(moment.utc(item.to).endOf('day')) ? item.to : to;
    return {...item, from: itemFrom, to: itemTo};
  });
};

export const calcPrice = (prices: DBPrice[], from: Date, to: Date, people: number): CalcPriceResult => {
  const moment = useMoment();
  const matchingPrices = getMatchingPrices(prices, from, to);
  const cleaning = matchingPrices.sort((a, b) => a.cleaning - b.cleaning)?.[0]?.cleaning || 0;
  const additionalPeople = people > BASE_PRICE_PEOPLE;
  const total =
    cleaning +
    matchingPrices.reduce((prev, item) => {
      const additionalPriceTotal = item.additional * (people - BASE_PRICE_PEOPLE);
      const pricePerNight = item.base + (additionalPeople ? additionalPriceTotal : 0);
      return (
        prev +
        pricePerNight *
          moment
            .utc(item.to)
            .endOf('day')
            .diff(moment.utc(item.from).startOf('day'), 'days')
      );
    }, 0);
  return {
    total,
    people,
    cleaning,
    items: matchingPrices.map(price => ({
      from: price.from,
      to: price.to,
      base: price.base,
      cleaning: price.cleaning,
      additional: price.additional,
      name: price.name,
    })),
  };
};
